import React, {useContext} from 'react';
import {Maybe} from 'monet';
import {AccountNoCtx} from '@/b2b/pages/Clients/DocumentList';
import {mapWithIndex} from '@/util';
import Icon from '@/views/shared/Icon';
import DownloadFileButton from '@/views/shared/DownloadFileButton';

const CategoryItem = ({item: {text, filePath}}) => {
  const accountNo = useContext(AccountNoCtx);
  const path = `/b2b/clients/download_document?account_no=${accountNo}&file=${filePath}`;
  return (
    <li className='pl-5'>
      <span>
        <Icon icon='file' />{' '}
      </span>
      <DownloadFileButton className='btn btn-link px-0' path={path}>
        {text}
      </DownloadFileButton>
    </li>
  );
};

const DocumentCategory = ({item}) => (
  <>
    {Maybe.fromFalsy(item.children)
      .map(() => (
        <li className='pl-5' key={item.text}>
          <ul>
            <span>
              <Icon icon='folder-open' /> {item.text}
            </span>
            {mapWithIndex((childrenItem, idx) => (
              <DocumentCategory
                item={childrenItem}
                key={`doc_category_${idx}`}
              />
            ))(item.children)}
          </ul>
        </li>
      ))
      .orElse(<CategoryItem item={item} />)}
  </>
);

export default DocumentCategory;
